import React, { FC } from 'react';

// Material-UI imports
import { alpha, useTheme } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// Project imports
import Avatar from 'ui-component/extended/Avatar';

// Assets
import ChatBubbleTwoToneIcon from '@mui/icons-material/ChatBubbleTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import { CreditReports } from 'Application/models';
import { getBackgroundColor } from 'Application/utils';
import { format } from 'date-fns';

// ==============================|| CREDIT REPORT LIST ||============================== //

interface ListProps {
    data: {
        // Adjusted to match the actual data structure
        currentPage: number;
        totalPages: number;
        totalItems: number;
        content: CreditReports[];
        // Ensure this matches your CreditReports interface
    };
    currency: string;
}

export const List: FC<ListProps> = ({ data, currency }) => {
    const theme = useTheme();
    const { content } = data; // Destructure content from data

    console.log(content, 'content from data');

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>Allocated By</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Credit Amount issued ({currency})</TableCell>
                        {/* <TableCell>Policy Number</TableCell> */}
                        {/* <TableCell align="center" sx={{ pr: 3 }}>Actions</TableCell> */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {content && content.length > 0 ? (
                        content.map((row: CreditReports, index: number) => (
                            <TableRow hover key={index}>
                                <TableCell>
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        <Avatar
                                            alt="User Avatar"
                                            sx={{
                                                backgroundColor: getBackgroundColor(row.usedBy[0])
                                            }}
                                        >
                                            {row.usedBy[0].toUpperCase()}
                                        </Avatar>
                                        <Stack>
                                            <Stack direction="row" alignItems="center" spacing={0.25}>
                                                <Typography variant="subtitle1">{row.usedBy}</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </TableCell>
                                <TableCell>{row.usedAt ? format(new Date(row.usedAt), 'MM-dd-yyyy') : 'N/A'}</TableCell>

                                <TableCell>{row.amount}</TableCell>
                                {/* <TableCell>{row.policyNumber}</TableCell> */}
                                {/* <TableCell align="center" sx={{ pr: 3 }}>
                                    <Stack direction="row" justifyContent="center" alignItems="center">
                                        <Tooltip placement="top" title="Message">
                                            <IconButton color="primary" aria-label="message" size="large">
                                                <ChatBubbleTwoToneIcon sx={{ fontSize: '1.1rem' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip placement="top" title="Block">
                                            <IconButton
                                                color="primary"
                                                sx={{
                                                    color: 'orange.dark',
                                                    borderColor: 'orange.main',
                                                    '&:hover': { bgcolor: 'orange.light' }
                                                }}
                                                size="large"
                                            >
                                                <BlockTwoToneIcon sx={{ fontSize: '1.1rem' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                </TableCell> */}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={5}>
                                <Typography variant="subtitle1" align="center">
                                    No Reports available
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default List;
